import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs/Subscription';
import { UserService } from "../../../../injections/user.service";
import { AuthService } from "../../../../injections/auth.service";

@Component({
    selector: 'modal-contact',
    templateUrl: '../../templates/partials/modal-contact.html'
})
export class ModalContactComponent implements OnInit {

    public showModal;
    public data;
    @ViewChild('officeModal') public officeModal:ModalDirective;
    public subscription: Subscription;
    constructor(private _user: UserService) { }

    public onHidden():void{
        this.closeModal();
    }

    public removeContactPerson(){
        /*this._user.removeContactPerson(this.data["data"]["id"]).subscribe( result => {
            if(result == "OK"){
                this.closeModal();
                this._user.hideModal(this.data);
            }
        })*/      
    }

    public removeOffice(){
        /*this._user.deleteUserOffice(this.data["data"]["id"]).subscribe( result => {
            if(result == "OK"){
                this.closeModal();
                this._user.hideModal(this.data);
            }
        });*/
    }

    public showModalTemplate() {
        (this.showModal) ? this.officeModal.show() : this.officeModal.hide();;
    }

    public closeModal():void{
        this.showModal = false;
        this.showModalTemplate();
    }

  
    ngOnInit() {

         this.subscription = this._user.showModalObservable().subscribe(result => {
             //console.log(result);
             this.showModal = true;
             this.data = result;
             this.showModalTemplate();
        });
     }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/modal-contact.component.ts